import { IDynamicKeyValue, INameId } from '@modeso/types__aumico-lib-core-be';
export interface IComponentOptionsDialogProperties {
    name: string;
    property: IDynamicKeyValue | string; // to be used as formControlName
    value?: boolean | IDynamicKeyValue | IDynamicKeyValue[];
    identifier: string;
    required: boolean;
    dynamic?: boolean;
    toggle?: boolean;
    selection?: boolean;
    selectionOptions?: INameId[];
}
